<template>
    <main-layout :showHeader="false">
        <template slot="body">
            <div class="login">
                <div class="login__block d-block" id="l-forget-password">
                    <div class="login__block__header palette-Purple bg">
                        <i class="zmdi zmdi-account-circle"></i>
                        {{ $t('LBL_RESET_PASSWORD_TITLE') }}
                    </div>

                    <form class="login__block__body" @submit.prevent="onSubmit">
                        <p class="mt-4">{{ $t('LBL_RESET_PASSWORD_TEXT') }}</p>

                        <base-field v-model="email" name="email" type="email" :label="$t('LBL_EMAIL_ADDRESS')" :isCentered="true"
                                    :mandatory="true" :isFloat="true"></base-field>

                        <div v-if="error" class="alert alert-warning" role="alert">
                            {{ error }}
                        </div>

                        <button type="submit" href="index.html" class="btn btn--icon login__block__btn"><i class="zmdi" :class="{ 'zmdi-check': !showLoader, 'zmdi-refresh zmdi-hc-fw rotating': showLoader}"></i></button>

                        <div class="mt-5">
                            <router-link :to="{name: 'Login'}">{{ $t('LBL_GOTO_LOGIN_PAGE') }}</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from '@/layout/Main'
    import BaseField from '@/components/form_elements/Base'
    import AppHelper from "../helper";

    export default {
        data() {
            return {
                email: '',
                showLoader: false,
                error: ''
            }
        },

        components: {
            'base-field': BaseField,
            'main-layout': MainLayout,
        },

        $_veeValidate: { validator: "new" },

        methods: {
            async onSubmit() {
                await this.$validator.validateAll()

                if(!this.errors.any() && !this.showLoader){

                    this.showLoader = true
                    var response = await Api.resetPassword(this.email)
                    this.showLoader = false

                    if(response.success){
                        AppHelper.notify(this.$t('LBL_RESET_PASSWORD_DONE'), 'info')
                        this.$router.push({name: 'Login'})
                    }
                    else if(!AppHelper.empty(response.error.label)){
                        this.error = response.error.label
                    }
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/PasswordRecovery.vue